module.exports = __webpack_public_path__ + "ba3dc083.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/005-settings.png
// module id = 1467
// module chunks = 4